import { dynamicTrackingOnPhotogallery } from '../services/tracking/parsely-tracking-service';
import { satelliteTracker } from '../services/tracking/satellite-tracking-service';

const COMSCORE_TRACKING_EVENT = 'comscore_track';
const GALLERY_TRACKING_EVENT = 'change_gallery';
const PAGEVIEW_CANDIDATE_PATH = '/resources/xml/pvc.xml'; // There is a rule for no-caching it in the service-worker
export const EDIT_PAGE_VIEW_EVENT = 'editpv';

export const WPN_ANALYTICS_EVENTS = Object.freeze({
  OPEN: 'push_notification_open',
  JOIN: 'push_notification_join',
  EDIT: 'push_notification_edit',
  ICONA: 'push_notification_icona',
});

export const BTI_ANALYTICS_EVENTS = Object.freeze({
  // modale break the ice
  OPEN: 'modale_bti_open',
  CLICK: 'modale_bti_click',
});

export const CTA_HEADER_ANALYTICS_EVENTS = Object.freeze({
  // button "personalizza"
  CLICK: 'cta_header_area_riservata',
});

export const PLAYLIST_INLINE_ANALYTICS_EVENTS = Object.freeze({
  GALLERY_TYPE: 'video-playlist-inline',
  CLICK_ON_PREV: 'gi_click_prev',
  CLICK_ON_NEXT: 'gi_click_next',
});

/**
 * Track change photo gallery
 * @param {*} hashPhotoCount the # of the gallery to track
 */
export const trackPhotoGallery = (hashPhotoCount) => {
  dynamicTrackingOnPhotogallery();
  satelliteTracker.trackInWeb(GALLERY_TRACKING_EVENT, { hash: hashPhotoCount });
};

/**
 * Track Comscore PVC
 * NOTE: In order to test it go on network and filter by "scorecard" (for the satellite) and "pvc" (for the pageview_candidate)
 */
export const trackComscore = () => {
  satelliteTracker.trackInWeb(COMSCORE_TRACKING_EVENT);
  fetch(`${self.location.origin}${PAGEVIEW_CANDIDATE_PATH}`);
};

/**
 * Track new pageview (i.e. on HP or preferences page when we click on tabs)
 * @param {String} suffix
 */
export const trackPageView = (suffix) => {
  satelliteTracker.trackInWeb(EDIT_PAGE_VIEW_EVENT, {
    pagename: `${window.digitalData.page.pageInfo.pageName}:${suffix}`,
  });
};
